import { render, staticRenderFns } from "./CompraDiretaVisualizacao.vue?vue&type=template&id=3b4511ae"
import script from "./CompraDiretaVisualizacao.vue?vue&type=script&lang=js"
export * from "./CompraDiretaVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaVisualizacao.vue?vue&type=style&index=0&id=3b4511ae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports